module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"2","matomoUrl":"https://matomo.prismref.ca/","siteUrl":"https://prismref.ca","requireConsent":true},
    }]
